import React from 'react';
import { drapcodeIcon } from '../../common/custom/icon-library';

const ParentCard = ({ icon, children, header, subtitle }) => {
  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <div className="card">
        <div className="card-header card-header-icon" data-background-color="drapcode-dark-blue">
          <i className={`wb ${drapcodeIcon(icon)}`}></i>
        </div>
        <div className="card-content">
          <h5 className={`card-title ${subtitle && 'mb-0 pb-0'}`}>{header}</h5>
          {subtitle && <p>{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default ParentCard;
